export default __webpack_public_path__ + "e8b7336c52b021fd32bd6d822ad04bda.png";